import React from 'react'
import Wrapper from '../../components/wrapper'
import PropTypes from 'prop-types'
import './styles.css'
import moment from '../../helpers/moment'
import Loader from '../../components/loader'

export class RestaurantPoolScheduleConfirm extends React.Component {

  render() {
    const rowCount = this.props.validScheduleRows.length
    const disabledClassName = this.props.isActionDisabled ? 'legacy-disabled-action' : ''
    return <Wrapper  title={'Pool Schedule Confirmation'} >
      <div className="restaurant-pool-schedule pool-schedule-confirmation">
        <h5>{rowCount} row{rowCount > 1 ? 's':''} to be scheduled</h5>
        <table className="table">
          <thead>
            <tr>
              <th scope="col">ID</th>
              <th scope="col">Restaurant name</th>
              <th scope="col">New pool</th>
              <th scope="col">Start date</th>
            </tr>
          </thead>

          <tbody>
            {this.props.validScheduleRows.map(schedule=>{

              const startDateMoment = moment.parseZone(schedule.startDateUtc, moment.ISO_8601, true)

              return <tr key={schedule.id}>
                <td className="align-middle">{schedule.restaurant.id}</td>
                <td className="align-middle">{schedule.restaurant.name}</td>
                <td className="align-middle">{!schedule.pool.name.trim() ? 'No pool': schedule.pool.name}</td>

                <td className="align-middle">
                  <abbr title={startDateMoment.format("dddd, MMMM Do YYYY, HH:mm:ss ([GMT]Z)")}>{startDateMoment.format("DD-MMM-YYYY")}</abbr>
                </td>
              </tr>
            })}
          </tbody>
        </table>

        <div className="edit-button-bar text-right">
          {this.props.isLoading ? <Loader/> : null}
          <button
            id="btnBack"
            className="btn btn-sm btn-secondary mr-1"
            disabled={this.props.isLoading}
            onClick={() => this.props.onBack()}>
              Back
          </button>
          <span title={this.props.disabledTitle}>
            <button
              id="btnRetryErrors"
              className={`btn btn-sm btn-primary ${disabledClassName}`.trim()}
              disabled={this.props.isLoading || this.props.isActionDisabled}
              onClick={() => this.props.onSubmit(this.props.validScheduleRows)}>
                Confirm and save schedules
            </button>
          </span>
        </div>

      </div>
    </Wrapper>
  }
}

RestaurantPoolScheduleConfirm.propTypes = {
  onBack: PropTypes.func.isRequired,
  onSubmit:  PropTypes.func.isRequired,

  isLoading: PropTypes.bool,
  isActionDisabled: PropTypes.bool,
  disabledTitle: PropTypes.string,
  validScheduleRows: PropTypes.array.isRequired,
}

RestaurantPoolScheduleConfirm.defaultProps = {
  isActionDisabled: false,
  disabledTitle: ''
}

export default RestaurantPoolScheduleConfirm



// WEBPACK FOOTER //
// ./src/containers/restaurant-pool-schedule/RestaurantPoolScheduleConfirm.js